import { MemberFollowUpItem } from '@core/api/services/member-follow-up-api.service';
import { MemberRow } from '../models/unit.model';

export function getUpcomingBirthdays(members: MemberRow[], today: Date) {
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const end = new Date(start);
  end.setDate(end.getDate() + 7);
  return members.filter(member => !!member.birthDate && member.status !== 'Departed').map(member => {
    const birth = member.birthDate!;
    let date = new Date(start.getFullYear(), birth.getMonth(), birth.getDate());
    if (date < start) date = new Date(start.getFullYear() + 1, birth.getMonth(), birth.getDate());
    return { member, date, isToday: date.getTime() === start.getTime() };
  }).filter(birthday => birthday.date < end)
    .sort((a, b) => a.date.getTime() - b.date.getTime()).slice(0, 2);
}

export function summarizeCommunion(items: MemberFollowUpItem[], today: Date) {
  const cutoff = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  cutoff.setDate(cutoff.getDate() - 14);
  return {
    total: items.length,
    pending: items.filter(item => item.lastHolyCommunionDate &&
      new Date(`${item.lastHolyCommunionDate.slice(0, 10)}T00:00:00`) < cutoff).length,
  };
}
